import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { checkIn, checkOut, register, unregister, fetchUsers } from '../actions/users.js'
import {
  fetchEvents,
  fetchEventsLinks,
  showUpdateEventForm,
  showNotificationForm,
  deleteEvent,
  hideAttendees,
  showAttendees,
  showPastEvents,
  updateFilter,
  updateEvent,
  changePage
} from '../actions/events.js'
import { fetchBuildings } from '../actions/buildings.js'
import { fetchCompanies } from '../actions/companies.js'

import { connect } from 'react-redux'

import moment from 'moment'

import './Events.css'

import { Card, CardText } from 'material-ui/Card'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'

import FlatButton from 'material-ui/FlatButton'
import RaisedButton from 'material-ui/RaisedButton'
import CircularProgress from 'material-ui/CircularProgress'
import Avatar from 'material-ui/Avatar'
import { List, ListItem } from 'material-ui/List'
import Subheader from 'material-ui/Subheader'
import Divider from 'material-ui/Divider'
import Dialog from 'material-ui/Dialog'
import Toggle from 'material-ui/Toggle'
import Checkbox from 'material-ui/Checkbox'
import SelectField from 'material-ui/SelectField'
import Paper from 'material-ui/Paper'
import AutoComplete from 'material-ui/AutoComplete'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import ConfirmButton from 'material-ui-confirm-button'

import Delete from 'material-ui/svg-icons/action/delete'
import Edit from 'material-ui/svg-icons/image/edit'
import ActionSupervisorAccount from 'material-ui/svg-icons/action/supervisor-account'

import ActionCheckCircle from 'material-ui/svg-icons/action/check-circle'
import ContentRemoveCircle from 'material-ui/svg-icons/content/remove-circle'
import NotificationTapAndPlay from 'material-ui/svg-icons/notification/tap-and-play'
import ActionVisibility from 'material-ui/svg-icons/action/visibility'
import ActionVisibilityOff from 'material-ui/svg-icons/action/visibility-off'
import Pagination from 'material-ui-pagination'

import AddEvent from '../components/events/AddEvent'
import UpdateNotifications from '../components/events/UpdateNotifications'

const style = {
  margin: 0
}

const toggle = {
  marginLeft: 10
}

const iconStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
  width: 25
}

class Events extends Component {
  static defaultProps = {
    filter: {
      buildingId: ' ',
      companyId: ' '
    },
    pageNumber: 1,
    itemsPerPage: 50,
    paginationDisplay: 10
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    this.fetchPageEvents()
    dispatch(fetchUsers())
    dispatch(fetchEventsLinks())
    dispatch(fetchCompanies())
    dispatch(fetchBuildings())
    document.title = 'Events - Admin - Better Spaces'
  }

  componentDidUpdate() {
    if (this.props.pageOrFilterChanged) {
      this.fetchPageEvents()
    }
  }

  fetchPageEvents() {
    const { dispatch } = this.props
    dispatch(
      fetchEvents(
        { ...this.props.filter, showPastEvents: this.props.showPastEvents },
        (this.props.pageNumber - 1) * this.props.itemsPerPage,
        this.props.itemsPerPage
      )
    )
  }

  updateFilter(name, event, index, value) {
    const { dispatch } = this.props
    dispatch(updateFilter(name, value))
  }

  showAddEventForm() {
    const { dispatch } = this.props
    dispatch(showUpdateEventForm({ sessions: [], eventLink: {} }))
  }

  enableEvent(event) {
    const { dispatch } = this.props
    event.enabled = true
    dispatch(updateEvent(event))
  }

  disableEvent(event) {
    const { dispatch } = this.props
    event.enabled = false
    dispatch(updateEvent(event))
  }

  updateEvent(event) {
    const { dispatch } = this.props
    dispatch(showUpdateEventForm(event))
  }

  deleteEvent(event) {
    const { dispatch } = this.props
    dispatch(deleteEvent(event))
  }

  hideAttendees() {
    const { dispatch } = this.props
    dispatch(hideAttendees())
  }

  showAttendees(event) {
    const { dispatch } = this.props
    dispatch(showAttendees(event))
  }

  showNotificationForm(event) {
    const { dispatch } = this.props

    var notification = event.notification ? event.notification : { type: 'newEventNotification' }
    var reminder = event.reminder ? event.reminder : { type: 'newEventReminder' }

    reminder.alert = 0
    if (reminder.scheduledDate) {
      reminder.alert = moment.duration(moment(event.eventDate).diff(moment(reminder.scheduledDate))).asMinutes()
    }

    dispatch(showNotificationForm(notification, reminder, event))
  }

  togglePastEvents(event, enabled) {
    const { dispatch } = this.props
    dispatch(showPastEvents(enabled))
  }

  handleCheckIn(user, session, event, switched) {
    const { dispatch } = this.props

    let adminId = this.props.id

    if (switched) {
      dispatch(checkIn(user, session, adminId))
    } else {
      dispatch(checkOut(user, session, adminId))
    }
  }

  register(user, session) {
    const { dispatch } = this.props
    let adminId = this.props.id
    dispatch(register(user, session, adminId))
  }

  unregister(user, session) {
    const { dispatch } = this.props
    let adminId = this.props.id
    dispatch(unregister(user, session, adminId))
  }

  datasource(session) {
    var attendingUsers = session.attending
    attendingUsers = attendingUsers.map(user => user._id)
    var users = this.props.users
    users = users.filter(user => {
      return attendingUsers.indexOf(user._id) === -1
    })

    users = users.map(user => ({
      text: user.email,
      value: (
        <MenuItem primaryText={user.fullName + ' (' + user.email + ')'} rightAvatar={<Avatar src={user.image} />} />
      )
    }))

    return users
  }

  addAttendingUser(session, event, index) {
    var email = event
    if (index > -1) {
      email = event.text
    }

    var user = this.props.users.find(user => user.email.toLowerCase() === email.toLowerCase())
    if (user) {
      this.register(user, session)
    }
  }

  onPageChanged(newPageNumber) {
    const { dispatch } = this.props
    if (newPageNumber != this.props.pageNumber) dispatch(changePage(newPageNumber))
  }

  render() {
    if (
      this.props.eventsFetched &&
      this.props.companiesFetched &&
      this.props.buildingsFetched &&
      this.props.eventsLinksFetched
    ) {
      if (this.props.events) {
        var events = this.props.events

        const actions = [<FlatButton label='OK' primary={true} onClick={this.hideAttendees.bind(this)} />]

        return (
          <div>
            <AddEvent />
            <UpdateNotifications />
            {this.props.sessions ? (
              <Dialog
                autoScrollBodyContent={true}
                autoDetectWindowHeight={true}
                actions={actions}
                modal={true}
                open={this.props.sessions}>
                {this.props.sessions.length > 0 ? (
                  <div>
                    {this.props.sessions.map((session, index) => (
                      <div>
                        <List>
                          <Subheader>
                            {moment(session.startDateTime).format('H:mm')}&nbsp;&nbsp;&nbsp;
                            <AutoComplete
                              hintText='Add New Attendee'
                              dataSource={this.datasource(session)}
                              onNewRequest={this.addAttendingUser.bind(this, session)}
                              fullWidth={true}
                            />
                          </Subheader>
                          {session.attending.length > 0 ? (
                            <div>
                              {session.attending.map((user, index) => (
                                <ListItem
                                  primaryText={user.fullName + ' (' + user.email + ') '}
                                  rightAvatar={<Avatar src={user.image} />}
                                  leftCheckbox={
                                    <Checkbox
                                      checkedIcon={<ActionCheckCircle />}
                                      uncheckedIcon={<ActionCheckCircle />}
                                      checked={session.checkedIn.map(user => user._id).indexOf(user._id) > -1}
                                      onCheck={this.handleCheckIn.bind(this, user, session)}
                                    />
                                  }
                                  rightXIconButton={
                                    <IconButton>
                                      <ContentRemoveCircle />
                                    </IconButton>
                                  }
                                />
                              ))}
                            </div>
                          ) : (
                            'Nobody is attending this session'
                          )}
                        </List>
                        <Divider />
                      </div>
                    ))}
                  </div>
                ) : (
                  'No attendees'
                )}
              </Dialog>
            ) : null}
            <div>
              <div style={{ float: 'left', width: '100%' }}>
                <div style={{ float: 'left' }}>
                  {this.props.role.length > 0 && this.props.role.charAt(0) >= '2' ? (
                    <RaisedButton
                      className='hidden-xs hidden-sm'
                      label='Add Event'
                      primary={true}
                      style={style}
                      onClick={this.showAddEventForm.bind(this)}
                    />
                  ) : (
                    <div />
                  )}
                </div>
                <div style={{ float: 'right' }}>
                  <Toggle
                    onToggle={this.togglePastEvents.bind(this)}
                    toggled={this.props.showPastEvents}
                    label='Show past events'
                    labelPosition='right'
                    style={toggle}
                  />
                </div>
              </div>
              <div
                className='hidden-xs hidden-sm'
                style={{ float: 'left', width: '100%', paddingTop: '10px', paddingBottom: '10px' }}>
                <Paper style={style} zDepth={1}>
                  <div style={{ margin: '10px' }}>
                    <br />
                    Filter by:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <br />
                    <SelectField
                      floatingLabelText='Building'
                      value={this.props.filter.buildingId}
                      onChange={this.updateFilter.bind(this, 'buildingId')}>
                      <MenuItem value=' ' primaryText='All Buildings' />
                      {this.props.buildings.map((building, index) => (
                        <MenuItem value={building._id} primaryText={building.name} />
                      ))}
                    </SelectField>
                    &nbsp;&nbsp;&nbsp;
                    <SelectField
                      floatingLabelText='Company'
                      value={this.props.filter.companyId}
                      onChange={this.updateFilter.bind(this, 'companyId')}>
                      <MenuItem value=' ' primaryText='All Companies' />
                      {this.props.companies.map((company, index) => (
                        <MenuItem value={company._id} primaryText={company.name} />
                      ))}
                    </SelectField>
                    <br />
                  </div>
                </Paper>
              </div>
              <div>
                <Pagination
                  total={Math.ceil(this.props.totalEventsAfterFilters / this.props.itemsPerPage)}
                  current={this.props.pageNumber}
                  display={this.props.paginationDisplay}
                  onChange={this.onPageChanged.bind(this)}
                />
              </div>
              <div style={{ float: 'left' }}>
                <Table selectable={false} responsive>
                  <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                      <TableHeaderColumn
                        className='info hidden-xs hidden-sm'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                        ID
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '10%' }}>
                        Title
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '8%' }}>
                        Date
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '8%' }}>
                        Company
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        className='info'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '8%' }}>
                        Building
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        className='info hidden-xs hidden-sm'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '5%' }}>
                        Capacity
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        className='info hidden-xs hidden-sm hidden-md'
                        style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '48%' }}>
                        Description
                      </TableHeaderColumn>
                      <TableHeaderColumn className='info' style={{ width: '10%' }} />
                    </TableRow>
                  </TableHeader>
                  <TableBody displayRowCheckbox={false}>
                    {events.map((event, index) => (
                      <TableRow>
                        <TableRowColumn
                          className='info hidden-xs hidden-sm'
                          style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                          {event.index}
                        </TableRowColumn>
                        <TableRowColumn
                          className='info'
                          style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '10%' }}>
                          {event.eventLink ? event.eventLink.title : ''}
                        </TableRowColumn>
                        <TableRowColumn
                          className='info'
                          style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '8%' }}>
                          {moment(event.eventDate).format('DD-MMM-YYYY')}
                        </TableRowColumn>
                        <TableRowColumn
                          className='info'
                          style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '8%' }}>
                          {event.company ? event.company.name : ''}
                        </TableRowColumn>
                        <TableRowColumn
                          className='info'
                          style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '8%' }}>
                          {event.building ? event.building.name : ''}
                        </TableRowColumn>
                        <TableRowColumn
                          className='info hidden-xs hidden-sm'
                          style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '5%' }}>
                          {event.capacity}
                        </TableRowColumn>
                        <TableRowColumn
                          className='info hidden-xs hidden-sm hidden-md'
                          style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '48%' }}>
                          {event.eventLink ? event.eventLink.desc : ''}
                        </TableRowColumn>
                        {this.props.role.length > 0 && this.props.role.charAt(0) >= '2' ? (
                          <TableRowColumn
                            className='info'
                            style={{ wordWrap: 'break-word', whiteSpace: 'nowrap', width: '10%' }}>
                            <ConfirmButton
                              key={event._id}
                              isFlat={true}
                              style={iconStyle}
                              icon={<Delete />}
                              confirmMessage='	&#10004;'
                              cancelMessage='X'
                              secondary={true}
                              onSubmit={this.deleteEvent.bind(this, event)}
                            />
                            <FlatButton
                              className='hidden-xs hidden-sm'
                              icon={<Edit />}
                              style={iconStyle}
                              primary={true}
                              onClick={this.updateEvent.bind(this, event)}
                            />
                            <FlatButton
                              icon={<ActionSupervisorAccount />}
                              style={iconStyle}
                              primary={true}
                              onClick={this.showAttendees.bind(this, event)}
                            />
                            {this.props.role.length > 0 && this.props.role.charAt(0) == '3' ? (
                              <FlatButton
                                icon={<NotificationTapAndPlay />}
                                style={iconStyle}
                                primary={true}
                                onClick={this.showNotificationForm.bind(this, event)}
                              />
                            ) : null}

                            {event.enabled ? (
                              <FlatButton
                                icon={<ActionVisibility />}
                                style={iconStyle}
                                primary={true}
                                onClick={this.disableEvent.bind(this, event)}
                              />
                            ) : (
                              <FlatButton
                                icon={<ActionVisibilityOff />}
                                style={iconStyle}
                                secondary={true}
                                onClick={this.enableEvent.bind(this, event)}
                              />
                            )}
                          </TableRowColumn>
                        ) : (
                          <TableRowColumn />
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
              <div>
                <Pagination
                  total={Math.ceil(this.props.totalEventsAfterFilters / this.props.itemsPerPage)}
                  current={this.props.pageNumber}
                  display={this.props.paginationDisplay}
                  onChange={this.onPageChanged.bind(this)}
                />
              </div>
            </div>
          </div>
        )
      } else {
        return (
          <Card style={{ width: '100%', height: '100%' }}>
            <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>No Events Available</CardText>
          </Card>
        )
      }
    } else {
      return (
        <Card style={{ width: '100%', height: '100%' }}>
          <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>
            <CircularProgress size={80} thickness={5} style={{ marginLeft: '50%' }} />
          </CardText>
        </Card>
      )
    }
  }
}

const mapStateToProps = state => {
  const { isFetching } = state.eventsReducer

  if (isFetching) {
    return {
      isFetching
    }
  } else {
    return {
      ...state.eventsReducer,
      id: state.usersReducer.id,
      role: state.usersReducer.role
    }
  }
}

export default withRouter(connect(mapStateToProps)(Events))



// WEBPACK FOOTER //
// ./src/containers/Events.js